import React, { useState } from 'react';
import classes from "./CategoryPage.module.css";
import styles from './SubscriptionPage.module.css';
import CategoriesSection from '../components/CategoriesSection';
import Lottie from 'lottie-react';
import stars from "../animations/stars3.json";
import { useNavigate } from 'react-router-dom';
import { Link, useSearchParams } from "react-router";
import axios from 'axios';
import { sendOtp } from "../http/http"
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import LanguageSelector from './LanguageSelector';
import { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import TopHeroWithForm from './TopHeroWithImage';
import Terms from '../components/Terms';


const SubscriptionPage = ()=> {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [msisdn, setMsisdn] = useState('');
  const [loading, setLoading] = useState(false);
  const [ext_id, setExt_id] = useState('')
  const { lang } = useContext(LanguageContext);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    const extId = searchParams.get("ext_id") || uuidv4();
    setSearchParams({ ext_id: extId });
   setExt_id(extId)
    
    if (!msisdn) {
      toast.error("Please enter your mobile number");
      return;
    }
  //    navigate(`/otp`, {
  //   state: { msisdn }
  // });
   

    try {
      setLoading(true);
      const response = await sendOtp(msisdn);
      console.log("Response:", response);

      console.log("resmsg", response?.data?.msg)
      console.log("success", response?.data?.success)


      if (response?.data?.is_subscribed && response?.data?.success) {
        console.log("-----------------")
        if (response?.data?.success) {
          toast.success(response?.data?.msg);
          Cookies.set("user_msisdn", msisdn, { expires: 10 });
          navigate(`/home`);
        }

      }

      else if (!response?.data?.is_subscribed && response?.data?.success) {
        if (response?.data?.success) {
          toast.success(response?.data?.msg);
          console.log("msg", response?.msg)
          navigate(`/otp?ext_id=${extId}`, {
            state: {
              msisdn: msisdn
            }
          });
        }
      }
      else {
        toast.error(response?.data?.msg);
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while sending OTP!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
      <div className={styles.container}>
         <LanguageSelector />
  
        <div className={styles.topImageWrapper}>
      <img
        src={
          lang === "eng"
            ? "/assets/images/kidsenglishimage.png"
            : "/assets/images/new.jpeg"
        }
        alt="kids"
        className={styles.topImage}
      />
    </div>
        { <Lottie
          animationData={stars}
          loop={true}
          autoplay={true}
          initialSegment={[0, 100]}
          className={classes.background_animation}
        /> }
        <div className={styles.card}>
           
          <h1 className={styles.title}>{lang =="eng" ? 'Fill Your Mobile Number':'أدخل رقم هاتفك المحمول'}</h1>
          {/* <p className={styles.desc}>{lang=="eng" ? "Get fun educational content delivered via Mobily subscription.":"احصل على محتوى تعليمي ممتع عبر اشتراك موبايلي."}</p> */}

          <form onSubmit={handleSubscribe} className={styles.form}>
            {/* <label className={styles.label}>{lang=="eng" ? "Mobile Number" : "رقم الهاتف المحمول"}</label> */}
            <input
              className={styles.input}
              value={msisdn}
              onChange={(e) => setMsisdn(e.target.value)}
              placeholder="9665XXXXXXXX"
              inputMode="tel"
            />
            <button
              className={styles.button}
              type="submit"
              disabled={loading}
            >
              {loading ? (lang === "ar" ? "جاري..." : "Loading...") : (lang === "ar" ? "اشترك" : "Subscribe")}
            </button>
             <Link className={styles.formLink} to={`/login?ext_id=${ext_id}`}>{lang=="eng" ? "Already a user, Login" : "أنت مستخدم بالفعل، قم بتسجيل الدخول"}</Link> 
          </form>
        </div>
      </div>
      {/* <CategoriesSection /> */}
      <Terms />
    </>
  );
}

export default SubscriptionPage;













